import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CustomIconButton from '../../../../../../components/CustomIconButton/CustomIconButton';
import CustomUploadButton from '../../../../../../components/CustomUploadButton/CustomUploadButton';
import CloudUploadIcon from '../../../../../../components/Icons/CloudUploadIcon';
import arquivosStyles from '../Arquivos.scss';
import { uploadPlanoTrabalhoContratoEntePublico } from '../../../../../../store/modules/ContratosEntePublicoActions';

class UploadPlanoTrabalhoButton extends Component {
  getArquivoId = () => {
    return this.props.arquivo.idDocPlanoTrabalho;
  };

  isShown = () => {
    return (
      (!this.getArquivoId() &&
        this.props.auth.userPermissions.contratos.entePublico.uploadAssinado) ||
      this.props.auth.userPermissions.contratos.entePublico
        .changeUploadPlanoTrabalho
    );
  };

  isLoading = () => {
    return this.props.contratosEntePublico.loadingAlteraStatus;
  };

  isDisabled = () => {
    const arquivo = this.props.arquivo;
    return (
      this.isLoading() ||
      this.props.contratosEntePublico.loadingAlteraArquivo ||
      (!this.props.auth.userPermissions.contratos.editEvenWhenDisabled &&
        (!arquivo.isLatest || !arquivo.idDocNaoAssinado || !arquivo.ativo))
    );
  };

  uploadAction = (data, callbackProgress, callbackSuccess, callbackError) => {
    this.props.uploadPlanoTrabalhoContratoEntePublico(
      data.file,
      this.props.arquivo.id,
      this.props.arquivo.versaoContrato,
      callbackSuccess,
      callbackError,
      (obj) => callbackProgress(obj.percent)
    );
  };

  render() {
    const arquivo = this.props.arquivo;
    return arquivo && this.isShown() ? (
      <CustomUploadButton
        id={arquivo.id}
        hideLabel
        className={arquivosStyles.rootClassName + '-action-button'}
        buttonComponent={CustomIconButton}
        buttonComponentProps={{
          id: 'upload-plano-trabalho-' + arquivo.id,
          size: 'small',
          icon: <CloudUploadIcon />,
          theme: 'pufvYellow',
          tooltip:
            this.props.languageValues
              .cadastroContratoArquivosUploadPlanoTrabalho,
          tooltipProps: {
            className:
              arquivosStyles.rootClassName + '-action-button-tooltip-caller',
          },
        }}
        uploadAction={this.uploadAction}
        uploadActionData={{}}
        feedbackOnModal
        feedbackOnModalTitle={
          this.props.languageValues
            .cadastroContratoArquivosUploadingPlanoTrabalho
        }
        disabled={this.isDisabled()}
        uploadActionSuccessCallback={this.props.refreshStep}
      />
    ) : null;
  }
}

UploadPlanoTrabalhoButton.propTypes = {
  id: PropTypes.string.isRequired,
  arquivo: PropTypes.object.isRequired,
  refreshStep: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePublico: state.contratosEntePublico,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      uploadPlanoTrabalhoContratoEntePublico,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadPlanoTrabalhoButton);
